import React, { useEffect, useState, Fragment } from 'react'
import {
  Typography,  
  Select,  
  MenuItem,
  Paper,  
  CircularProgress,
  ListItem,
  ListItemText,
  ListItemIcon,
  List,
  Checkbox,  
  Snackbar,
  SnackbarContent,
  Backdrop,
} from '@material-ui/core'
import { Public, Warning} from '@material-ui/icons'
import BarChart from '../charts/BarChart2'
import Cookies from 'js-cookie'
import MonthPicker from '../calendar/MonthPicker'
import AskReport from '../AskReport'
import PageHeader from '../PageHeader'
import DemoExcel from './DemoExcel'

import moment from 'moment'

const date_format = "YYYY-MM"

const Demographics = (props) => {
  const { dark } = props
  const token = Cookies.get("token")  
  const initialMinYearmo = moment().subtract(1, "years").startOf("year")
  const initialMaxYearmo = moment()  
  const [demographicsData, setDemographicsData] = useState(null)
  const [dataByLocation, setDataByLocation] = useState(null)
  const [defaultData, setDefaultData] = useState(null)
  const [selectedData, setSelectedData] = useState(null)
  const [locationsList, setLocationsList] = useState(null)
  const [locType, setLocType] = useState("market")
  const [metric, setMetric] = useState("Age Range")
  const [checked, setChecked] = useState([])
  const [dates, setDates] = useState({minyearmo: initialMinYearmo, maxyearmo: initialMaxYearmo})
  const [months, setMonths] = useState(0)  
  const [errorMsg, setErrorMsg] = useState("")
  const [snackbar, setSnackbar] = useState(false)
  const [dataLoad, setDataLoad] = useState(false)
  const [chartLoad, setChartLoad] = useState(false)
  const [hasData, setHasData] = useState(false)

  const getDemoData = () => {
    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/market?min_yearmo=${initialMinYearmo.format(date_format)}&max_yearmo=${initialMaxYearmo.format(date_format)}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/markets?active=1`, {headers: {token: token}}),
    ])

    request.then(([response, response2, response3]) => Promise.all([response.json(), response2.json(), response3.json()]))
    .then(([data, data2, data3]) => {    
      if(data2) {
        setHasData(true)
        setDemographicsData(data)
        setDefaultData(data2)
        setDataByLocation(data2)
        setLocationsList(data2)
        setSelectedData(data2.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
        setChecked(data3)
        setMonths(dates.maxyearmo.diff(dates.minyearmo, "months"))  
      } else {
        setHasData(false)
        setDemographicsData([])
        setLocationsList([])
        setSelectedData([])
        setChecked([])        
        setMonths(dates.maxyearmo.diff(dates.minyearmo, "months"))  
      }
    })
  }

  useEffect(() => getDemoData(), [])

  const getBarChartData = (data) => {    
    console.log(data)
    
    let metricLength = data.map(({Data}) => Data.length)[0]    
    let series = [
      {name: "% of Customers", data: [], counts: [], attr: "Customers"},
      {name: "% of Customers Baseline", data: [], counts: [], attr: "Customers_Baseline"},
      {name: "% of Boomerang Browsers", data: [], counts: [], attr: "Boomerang"},
    ]
    
    for(let i = 0; i < metricLength; i++) {
      for(let j = 0; j < series.length; j++) {
        let count = selectedData.map(({Data}) => Data[i][`${series[j]["attr"]}`]).reduce((a,b) => a + b, 0)
        series[j].counts.push(count)
      }
    }    

    series.map(({counts, data}) => counts.forEach(element => {
      let total = counts.reduce((a,b) => a + b, 0)      
      let pct = element / total * 100
      data.push(parseFloat(pct.toFixed(2)))
    }))

    return series
  }

  const handleLocTypeChange = (e) => {
    const {value} = e.target
    const { minyearmo, maxyearmo } = dates
    
    setDataLoad(true)
    
    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/${value}?min_yearmo=${minyearmo.format(date_format)}&max_yearmo=${maxyearmo.format(date_format)}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/${value}?min_yearmo=${minyearmo.format(date_format)}&max_yearmo=${maxyearmo.format(date_format)}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${value}s`, {headers: {token: token}})      
    ])

    request.then(([response, response2, response3]) => Promise.all([response.json(), response2.json(), response3.json()]))
    .then(([data, data2, data3]) => {      
      if(data) {        
        setDataLoad(false)
        setDataByLocation(data)
        setLocationsList(data)
        setDefaultData(data)
        setSelectedData(data.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
        setChecked(data.map(({Label}) => Label))
      } else {
        setDataLoad(false)
        setLocationsList([])
        setDataByLocation([])
        setSelectedData([])
        setChecked(data3)
      }      
      
      setLocType(value)
    })    
  }

  const handleMetricChange = (e) => {
    const {value} = e.target
    let data = [...dataByLocation.filter(({Label}) => checked.includes(Label))]
    
    setMetric(value)
    setSelectedData(data.map(({Data}) => Data.filter(({MetricType}) => MetricType === value)[0]))    
  }

  const handleToggleCheck = (e, label) => {  
    if(label === "ALL") {
      if(checked.length === locationsList.length) {
        setChecked([])
        setDataByLocation([])
        setSelectedData([])
      }
      else {        
        setChecked(locationsList.map(({Label}) => Label))
        setDataByLocation(defaultData)
        setSelectedData(defaultData.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
      }
    } else {
      let newChecked = [...checked]
      let data = [...dataByLocation]
      let currentIdx = checked.indexOf(label)            
      
      if(currentIdx !== -1) {
        newChecked.splice(currentIdx, 1)
        data = data.filter(({Label}) => Label !== label)      
      } else {      
        let selected = defaultData.filter(({Label}) => Label === label)[0]      
        newChecked.push(label)
        data.push(selected)
      }    
      
      setChecked(newChecked)
      setDataByLocation(data)
      setSelectedData(data.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))      
    }
  }
  
  const handleDateChange = (value, valName) => {        
    setChartLoad(true)
    
    if(valName === "minYearmo") {
      const request = Promise.all([
        fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/${locType}?min_yearmo=${value.format(date_format)}&max_yearmo=${dates.maxyearmo.format(date_format)}`, {headers: {token: token}}),
        fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${locType}s`, {headers: {token: token}})
      ])

      request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
      .then(([data, data2]) => {        
        if(data) {
          let checkedData = data.filter(({Label}) => checked.includes(Label))
                    
          setChartLoad(false)
          setSelectedData(checkedData.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
          setLocationsList(data)
          setDataByLocation(data)
          setMonths(dates.maxyearmo.diff(value, "months"))          
        } else {
          setChartLoad(false)
          setSelectedData([])
          setMonths(data.maxyearmo.diff(value, "months"))
          setLocationsList([])
          setDataByLocation([])
          setSnackbar(true)
          setErrorMsg("Demographics data is not available for the selection(s) you have made. Please broaden your search and try again")
        }
      })
    } else {
      const request = Promise.all([
        fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/${locType}?min_yearmo=${dates.minyearmo.format(date_format)}&max_yearmo=${value.format(date_format)}`, {headers: {token: token}}),
        fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${locType}s`, {headers: {token: token}})
      ])          
      
      request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
      .then(([data, data2]) => {
        if(data) {
          let checkedData = data.filter(({Label}) => checked.includes(Label))
          setChartLoad(false)
          setSelectedData(checkedData.map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
          setLocationsList(data)
          setDataByLocation(data)
          setMonths(value.diff(dates.minyearmo, "months"))          
        } else {
          setChartLoad(false)
          setSelectedData([])
          setMonths(value.diff(dates.minyearmo, "months"))
          setLocationsList([])
          setDataByLocation([])
          setSnackbar(true)
          setErrorMsg("Demographics data is not available for the selection(s) you have made. Please broaden your search and try again")
        }
      })
    }

    setDates(prevState => ({...prevState, [valName.toLowerCase()]: value}))
  }

  const handleSliderChange = (values) => {
    let minYearmo = values[0]
    let maxYearmo = values[1]

    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/demoByLoc/${locType}?min_yearmo=${minYearmo}&max_yearmo=${maxYearmo}`, {headers: {token: token}})

    request.then(response => response.json())
    .then(data => {
      if(data) {        
        setSelectedData(data.filter(({Label}) => checked.includes(Label)).map(({Data}) => Data.filter(({MetricType}) => MetricType === metric)[0]))
        setLocationsList(data)
        setDataByLocation(data)
        setDates(prevState => ({...prevState, minyearmo: moment(minYearmo), maxyearmo: moment(maxYearmo)}))
      }
    })
    .catch(error =>{ console.log(error)})
  }

  const handleSnackbarClose = (e, reason) => {
    if(reason === "clickaway") setSnackbar(false)

    setSnackbar(false)
  }

  if(!selectedData) return <CircularProgress />  
  if(!hasData) return <AskReport />

  const renderSelectOptions = () => (
    demographicsData.map(({Key, MetricType}) => (
      <MenuItem key={Key} value={MetricType}><Typography variant="caption">{MetricType.toUpperCase()}</Typography></MenuItem>
    ))
  )

  return (
    <div id="demo-by-loc">
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <PageHeader details={{icon: <Public />, title: "DEMOGRAPHICS BY LOCATION"}} />
        <DemoExcel
          metricType={metric}
          minYearmo={dates.minyearmo}
          maxYearmo={dates.maxyearmo}
          selectedData={selectedData}
          marketSelected={checked}
          dataSeries={getBarChartData(selectedData)}
          categories={selectedData.map(({Data}) => Data.map(({MetricValue}) => MetricValue))[0]}
          dark={dark}
        />   
      </div>   
      <Backdrop open={chartLoad} style={{zIndex: 10000}}><CircularProgress style={{color: "#fff"}}/></Backdrop>
      <Fragment>
        <Snackbar
          open={snackbar}
          autoHideDuration={4500}
          onClose={handleSnackbarClose}
          anchorOrigin={{vertical: "top", horizontal: "center"}}
        >
          <SnackbarContent 
            message={
              <div className="snackbar">
                <Warning fontSize="small" fontWeight="bold" />
                <span style={{fontWeight: 600, marginLeft: "15px"}}>{errorMsg}</span>
              </div>
            }
          />
        </Snackbar>
      </Fragment>                    
      <div className="content">
        <Paper className={`chart-paper ${dark ? "bg-dk" : "bg-lt"}`}>          
          <BarChart
            categories={selectedData.length > 1 ? selectedData[0].Data.map(({MetricValue}) => MetricValue) : []}
            data={getBarChartData(selectedData)}
            height={700}
            colors={['#00c9db', '#2f5a7a', '#ff2b34']}
            darkMode={dark}
          />          
        </Paper>

        <Paper className={`filters-paper ${dark ?  "bg-dk" : "bg-lt"}`}>
          <div className="date-picker">
            <MonthPicker 
              maxValue={dates.maxyearmo}
              minValue={dates.minyearmo}
              maxSliderValue={months}              
              handleDateRange={handleDateChange}              
              handleSliderDateChange={handleSliderChange}
              darkMode={dark}
            />
          </div>
          <Select
            value={metric}
            variant="outlined"
            className={`demo-select ${dark ? "dk-select" : "lt-select"}`}
            onChange={handleMetricChange}
          >
            {renderSelectOptions()}
          </Select>
          <Select
            value={locType}            
            variant="outlined"
            className={`demo-select ${dark ? "dk-select" : "lt-select"}`}
            onChange={handleLocTypeChange}
          >
            <MenuItem value={"location"}><Typography variant="caption">BY LOCATION</Typography></MenuItem>
            <MenuItem value={"market"}><Typography variant="caption">BY MARKET</Typography></MenuItem>
          </Select>
          <List
            dense={true}
            className={`loc-list ${dark ? "list-dk" : "list-lt"}`}
            style={{height: `${locType === "market" ? "275px" : "500px"}`}}
          >
            {dataLoad ?
              <div className="loader">
                <CircularProgress style={{color: "#fff"}}/>
              </div>
            :
              <Fragment>
                <ListItem className="select-all"><ListItemText onClick={(e) => handleToggleCheck(e, "ALL")}><Typography variant="caption">{locationsList.length === checked.length ? "DESELECT" : "SELECT"} ALL {locType.toUpperCase()}S</Typography></ListItemText></ListItem>
                {locationsList.map(({Key, Label}) => (
                  <ListItem key={Key} dense>
                    <ListItemIcon>
                      <Checkbox edge="start" size="small" checked={checked.indexOf(Label) !== -1} onClick={(e) => handleToggleCheck(e, Label)}/>
                    </ListItemIcon>
                    <ListItemText><Typography variant="caption">{Label.toUpperCase()}</Typography></ListItemText>
                  </ListItem>
                ))}
              </Fragment>
            }
          </List>
          <Typography variant="caption" className={`loc-list-label ${dark ?  "dk" : "lt"}`}>{`${locType.toUpperCase()}S (${checked.length} of ${locationsList.length} SELECTED)`}</Typography>
          <br/>
        </Paper>
      </div>
    </div>
  )
}

export default Demographics
